// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"c906dd85","364":"7ff11b09","420":"7ff11b09","582":"7ff11b09","607":"7ff11b09"}[chunkId] + ".chunk.css";
};